class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
facetForm.addEventListener('mousedown', (e) => {
  if (e.target.matches('input[type="checkbox"]')) {
    const activeFilter = e.target.closest('.js-filter');
    if (activeFilter) activeFilter.open = false;
  }
});
facetForm.addEventListener('change', (e) => {
  const activeFilter = e.target.closest('.js-filter');
  if (activeFilter) activeFilter.open = false;
  setTimeout(() => {
    document.querySelectorAll('.js-filter[open]').forEach(el => {
      el.open = false;
    });
  }, 600);
});


    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searhParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.querySelector('.ProductCountDesktop');

    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    document.querySelectorAll('.js-filter[open]').forEach(el => el.setAttribute('data-loading', ''));

    if (countContainer) countContainer.classList.add('loading');
    if (countContainerDesktop) countContainerDesktop.classList.add('loading');

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

static renderSectionFromFetch(url, event) {
  fetch(url)
    .then(response => response.text())
    .then((responseText) => {
      const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
      parsedHTML.querySelectorAll('.js-filter').forEach(el => el.removeAttribute('open'));
      parsedHTML.querySelectorAll('script').forEach(s => s.remove());
      FacetFiltersForm.renderFilters(parsedHTML, event);
      FacetFiltersForm.renderProductGridContainer(parsedHTML);
      FacetFiltersForm.renderProductCount(parsedHTML);
      try { InitCustomFunctions(); } catch(e) { console.warn('InitCustomFunctions error:', e); }
      // Force close all desktop filters after everything
      document.querySelectorAll('#FacetFiltersForm .js-filter').forEach(el => {
        el.removeAttribute('open');
      });
      // Fix sort label after DOM replacement
      setTimeout(function() {
        const checked = document.querySelector('.dt-sort__container input[name="sort_by"]:checked');
        const label = document.querySelector('.dt-sort__container .facets__summary-label');
        if (checked && label) label.innerHTML = checked.getAttribute('data-value');
      }, 100);
    });
}

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    FacetFiltersForm.renderFilters(parsedHTML, event);
    FacetFiltersForm.renderProductGridContainer(parsedHTML);
    FacetFiltersForm.renderProductCount(parsedHTML);
    try { InitCustomFunctions(); } catch(e) { console.warn('InitCustomFunctions error:', e); }
  }

  static renderProductGridContainer(parsedHTML) {
    const newContainer = parsedHTML.getElementById('ProductGridContainer');
    newContainer.querySelectorAll('script').forEach(s => s.remove());

    document.getElementById('ProductGridContainer').innerHTML = newContainer.innerHTML;

    document.querySelectorAll('details[open]').forEach(el => {
      el.removeAttribute('open');
    });

    setTimeout(() => {
      document.querySelectorAll('menu-drawer').forEach(drawer => {
        drawer.closeMenuDrawer(new Event('click'));
      });

      const customOverlay = document.querySelector('.dt-custom-overlay');
      if (customOverlay) {
        customOverlay.style.display = 'none';
        customOverlay.style.visibility = 'hidden';
        customOverlay.style.opacity = '0';
        customOverlay.style.pointerEvents = 'none';
        customOverlay.classList.remove('active', 'is-visible', 'open');
      }

      document.body.classList.remove('overflow-hidden-mobile');
    }, 50);
  }

  static renderProductCount(parsedHTML) {
    const sourceCount = parsedHTML.getElementById('ProductCount');
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.querySelector('.ProductCountDesktop');
    const sourceDesktop = parsedHTML.querySelector('.ProductCountDesktop');

    if (sourceDesktop && containerDesktop) {
      containerDesktop.innerHTML = sourceDesktop.innerHTML;
      containerDesktop.classList.remove('loading');
    }
    if (!sourceCount || !container) return;

    container.innerHTML = sourceCount.innerHTML;
    container.classList.remove('loading');
  }

  static renderFilters(parsedHTML, event) {
  document.querySelectorAll('.js-filter[data-loading]').forEach(el => {
    el.removeAttribute('data-loading');
    el.removeAttribute('open');
  });

  const facetDetailsElements = parsedHTML.querySelectorAll(
  '#FacetFiltersForm .js-filter, #FacetFiltersPillsForm .js-filter'
);

  const matchesIndex = (element) => {
    const jsFilter = event ? event.target.closest('.js-filter') : undefined;
    return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
  };

  const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
  const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

  facetsToRender.forEach((element) => {
  const sourceLabel = element.querySelector('summary')?.getAttribute('aria-label')?.split(' (')[0].trim();

  let target = document.getElementById(element.id);

  if (!target && sourceLabel) {
    target = Array.from(document.querySelectorAll('#FacetFiltersForm .js-filter')).find(el => {
      const label = el.querySelector('summary')?.getAttribute('aria-label')?.split(' (')[0].trim();
      return label === sourceLabel;
    });
  }

  if (!target) return;
  const targetFieldset = target.closest('fieldset.facets-wrap') || target.parentElement;
  const sourceFieldset = element.closest('fieldset.facets-wrap') || element.parentElement;
  if (targetFieldset && sourceFieldset) {
    targetFieldset.innerHTML = sourceFieldset.innerHTML;
    const newTarget = targetFieldset.querySelector('.js-filter');
    if (newTarget) newTarget.removeAttribute('open');
  } else {
    target.innerHTML = element.innerHTML;
    target.removeAttribute('open');
  }
});

  FacetFiltersForm.renderActiveFacets(parsedHTML);
  FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender && event && event.target) {
  FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  // Close the matched filter after counts update
  const matchedFilter = event.target.closest('.js-filter');
  if (matchedFilter) matchedFilter.removeAttribute('open');
}

  // Force close all desktop filters after render
document.querySelectorAll('#FacetFiltersForm .js-filter').forEach(el => {
  el.removeAttribute('open');
});

  // Re-sync filter labels to close any mismatched/ghost filters
  document.querySelectorAll('#FacetFiltersForm .js-filter').forEach(el => {
    const summary = el.querySelector('summary');
    if (!summary) return;
    const label = summary.getAttribute('aria-label')?.split(' (')[0].trim();
    const span = summary.querySelector('span');
    if (span && label && span.textContent.trim() !== label) {
      el.removeAttribute('open');
    }
  });
}

static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      try {
        const source = html.querySelector(selector);
        if (!source) return;
        const target = document.querySelector(selector);
        if (!target) { console.warn('target missing:', selector); return; }
        source.querySelectorAll('script').forEach(s => s.remove());
        target.innerHTML = source.innerHTML;
        console.log('OK:', selector);
      } catch(e) {
        console.error('FAILED:', selector, e);
      }
    });

    try {
      const menuDrawer = document.getElementById('FacetFiltersFormMobile')?.closest('menu-drawer');
      if (menuDrawer && typeof menuDrawer.bindEvents === 'function') {
        menuDrawer.bindEvents();
        console.log('bindEvents OK');
      } else {
        console.warn('bindEvents not available');
      }
    } catch(e) {
      console.error('bindEvents FAILED:', e);
    }
  }

  static renderCounts(source, target) {
  const targetSelected = target.querySelector('.facets__selected');
  const sourceSelected = source.querySelector('.facets__selected');
  if (sourceSelected && targetSelected) {
    targetSelected.innerHTML = sourceSelected.innerHTML;
  }

  const targetSummary = target.querySelector('.facets__summary');
  const sourceSummary = source.querySelector('.facets__summary');
  if (targetSummary && sourceSummary) {
    targetSummary.innerHTML = sourceSummary.innerHTML;
  }
}

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ];
  }
    createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const sortFilterForms = document.querySelectorAll('facet-filters-form form');

    if (event.srcElement.className === 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });

      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') === -1
      ? ''
      : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
    InitCustomFunctions();
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach(element => {
      element.addEventListener('change', this.onRangeChange.bind(this));
    });
    this.setMinAndMaxValues();
    this.customRangeSlider();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
    InitCustomFunctions();
    this.customRangeSlider();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));
    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  customRangeSlider() {
    const $scroll = $('.js-range-slider');
    const $priceStart = $('.field__input_min');
    const $priceEnd = $('.field__input_max');
    const priceMin = parseFloat($scroll.data('min'));
    const priceMax = parseFloat($scroll.data('max'));
    let from = $priceStart.val() ? $priceStart.val() : 0;
    let to = $priceEnd.val() ? $priceEnd.val() : priceMax;
    const FacetXLarge = document.getElementById('FacetFiltersForm');
    const FacetXSmall = document.getElementById('FacetFiltersFormMobile');

    $scroll.ionRangeSlider({
    skin: 'round',
    type: 'double',
    hide_from_to: false,
    prefix: '£',
      min: priceMin,
      max: priceMax,
      from: from,
      to: to,
      onChange: updateInputs,
      onFinish: updateInputs
    });

    const initObj = $scroll.data('ionRangeSlider');

    function dispatchFacetEvent() {
      const width = $(window).width();
      if (width > 750) {
        const target = FacetXLarge || FacetXSmall;
        if (target) target.dispatchEvent(new Event('input'));
      } else {
        if (FacetXSmall) FacetXSmall.dispatchEvent(new Event('input'));
      }
    }

    function updateInputs(data) {
      from = data.from;
      to = data.to;
      $priceStart.val(from);
      $priceEnd.val(to);
      dispatchFacetEvent();
    }

    $priceStart.on('change', function() {
      let val = parseFloat($(this).val());
      if (val < priceMin) val = priceMin;
      else if (val > to) val = to;
      initObj.update({ from: val });
      $(this).val(val);
    });

    $priceEnd.on('change', function() {
      let val = parseFloat($(this).val());
      if (val < from) val = from;
      else if (val > priceMax) val = priceMax;
      initObj.update({ to: val });
      $(this).val(val);
    });
  }
}
customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}
customElements.define('facet-remove', FacetRemove);

class SidebarCarousel extends HTMLElement {
  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    new Swiper(this.querySelector('#swiper-sidebar-carousel'), {
      slidesPerView: 1,
      navigation: {
        nextEl: this.querySelector('#swiper-sidebar-next'),
        prevEl: this.querySelector('#swiper-sidebar-prev'),
      },
    });
  }
}
customElements.define('sidebar-carousel', SidebarCarousel);

// @license magnet:?xt=urn:btih:d3d9a9a6595521f9666a5e94cc830dab83b65699&dn=expat.txt MIT
